import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { DishCommentCard } from '@/entities/comment'
import { Offcanvas } from '@/entities/offcanvas'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/canteen/user-comments/comment/$commentId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка комментария')}>
      <DishCommentCard />
    </Offcanvas>
  )
}
